'use client';
import { ReactNode } from 'react';
import Image from 'next/image';
import cn from 'classnames';

import Text from '@/components/common/Text/Text';
import ChevronDownBlack from 'public/img/icon/chevron-down-black.svg';
import './AnimatedAccordion.style.scss';

type AnimatedAccordionProps = {
  className?: string;
  /** Accordion Content */
  children: ReactNode;
  /** Title of the accordion */
  title: ReactNode;
  open?: boolean;
  /** Callback to run when the user clicks on the accordion */
  onRequestChange?: (open: boolean) => void;
  /** What height should the accordion expand to when clicked? */
  expandedHeight: number;
  /** Value to pass in for 'transition' CSS value */
  transitionString?: string;
};

function AnimatedAccordion(props: AnimatedAccordionProps) {
  const {
    className = '',
    children,
    title,
    open,
    onRequestChange,
    expandedHeight,
    transitionString = 'all .6s ease-in-out'
  } = props;

  const handleRequestChange = () => {
    onRequestChange?.(!open);
  };

  return (
    <div className={cn('AnimatedAccordion', className)}>
      <div
        className='AnimatedAccordion-title cursor'
        onClick={handleRequestChange}
      >
        {typeof title === 'string' ? (
          <Text variant='title-xs'>{title}</Text>
        ) : (
          <>{title}</>
        )}
        <Image
          src={ChevronDownBlack}
          alt='close'
          className={cn('Accordion-header-arrow', { open })}
        />
      </div>
      <div
        className='AnimatedAccordion-content'
        style={{
          transition: transitionString,
          maxHeight: open ? expandedHeight : 0
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default AnimatedAccordion;
